<script>
  import { createEventDispatcher } from "svelte";

  const dispatch = createEventDispatcher();

  export let message = "";
  export let duration = 3000;
  export let visible = false;
  export let type = "success";
  export let manualClose = false;
  export let sellLeadsWidget = false;

  let timeout;

  $: if (visible && !manualClose) {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      visible = false;
    }, duration);
  }

  function closeToast() {
    dispatch("close-toast");
  }
</script>

<div
  class="chatwith-toast-message"
  class:cw-show={visible}
  class:cw-success={type === "success"}
  class:cw-warning={type === "warning"}
  class:cw-sell-leads-widget={sellLeadsWidget}
>
  <span>{message}</span>
  {#if manualClose}
    <button class="toast-close-button" on:click={closeToast}>✖</button>
  {/if}
</div>

<style>
  .chatwith-toast-message {
    position: relative;
    padding: 12px 16px;
    border-radius: 6px;
    font-size: 14px;
    font-weight: 600;
    margin-top: 10px;
  }

  .cw-success {
    background-color: #e6ffed;
    border: 1px solid #b7eb8f;
    color: #389e0d;
  }

  .cw-warning {
    background-color: #fff1f0;
    border: 1px solid #ffa39e;
    color: #cf1322;
  }

  .toast-close-button {
    background: none;
    border: none;
    color: inherit;
    font-size: 16px;
    position: absolute;
    right: 0;
    top: 0;
    cursor: pointer;
  }
</style>
